<app-table-standard-layout *ngIf="columnSettings$ | async; let columnSettings" [dataSource$]="transactions$" [title]="'Transactions'" [columnSettings]="columnSettings" ></app-table-standard-layout>
